[
  {
    "code": "TW-CHA",
    "name": "Changhua County"
  },
  {
    "code": "TW-CYI",
    "name": "Chiayi City"
  },
  {
    "code": "TW-CYQ",
    "name": "Chiayi County"
  },
  {
    "code": "TW-HSZ",
    "name": "Hsinchu City"
  },
  {
    "code": "TW-HSQ",
    "name": "Hsinchu County"
  },
  {
    "code": "TW-HUA",
    "name": "Hualien County"
  },
  {
    "code": "TW-KHH",
    "name": "Kaohsiung City"
  },
  {
    "code": "TW-KEE",
    "name": "Keelung City"
  },
  {
    "code": "TW-KIN",
    "name": "Kinmen County"
  },
  {
    "code": "TW-LIE",
    "name": "Lienchiang County"
  },
  {
    "code": "TW-MIA",
    "name": "Miaoli County"
  },
  {
    "code": "TW-NAN",
    "name": "Nantou County"
  },
  {
    "code": "TW-TPQ",
    "name": "New Taipei City"
  },
  {
    "code": "TW-PEN",
    "name": "Penghu County"
  },
  {
    "code": "TW-PIF",
    "name": "Pingtung County"
  },
  {
    "code": "TW-TXG",
    "name": "Taichung City"
  },
  {
    "code": "TW-TNN",
    "name": "Tainan City"
  },
  {
    "code": "TW-TPE",
    "name": "Taipei City"
  },
  {
    "code": "TW-TTT",
    "name": "Taitung County"
  },
  {
    "code": "TW-TAO",
    "name": "Taoyuan City"
  },
  {
    "code": "TW-ILA",
    "name": "Yilan County"
  },
  {
    "code": "TW-YUN",
    "name": "Yunlin County"
  }
]